import { alpha, Box, Chip, Stack, styled } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'transparent',
      transition: 'border-color 0.2s',
    },
    '&:hover fieldset': {
      borderColor: 'transparent',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#19A9AF',
      borderWidth: 1,
    },
    '& .MuiAutocomplete-endAdornment': {
      display: 'none',
    },
    '& .MuiOutlinedInput-input': {
      '&::placeholder': {
        color: theme.palette.text.secondary,
      },
    },
  },
}));

export const RenderValueChip = styled(Chip)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.grey[110], 0.5),
  '&:hover': {
    backgroundColor: alpha(theme.palette.grey[110], 0.5),
  },
}));

export const GroupHeader = styled(Stack)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
}));
